/**
 * Production builds keep console.log, console.info and console.debug quiet.
 *
 * Those lines carry names, emails, show titles and notification payloads,
 * and on a shared school computer anyone who opens the developer tools can
 * read what the last person's session logged. console.warn and
 * console.error stay: they are what a support request needs, and errors are
 * reported to Firestore by errorReporting.ts anyway.
 *
 * Imported for its side effect as the first import of index.tsx, so it runs
 * before any other module is evaluated.
 */
export function silenceProductionConsole(
  target: Pick<Console, 'log' | 'info' | 'debug'> = console,
  env: string | undefined = process.env.NODE_ENV,
): void {
  if (env !== 'production') return;
  const discard = () => {};
  target.log = discard;
  target.info = discard;
  target.debug = discard;
}

silenceProductionConsole();
